import script from "./moreButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./moreButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./moreButtonComponent.vue?vue&type=style&index=0&id=21eb24ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21eb24ea"]])

export default __exports__